<template>
  <div class="c-table" ref="table">
    <el-table class="common-el-table-styles" v-loading="loading" :data="data" :height="height" border stripe>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
      >
        <template slot-scope="scope">
          <div v-if="col.key === 'control'">
            <el-button type="text" size="small" @click="$emit('on-edit', scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="$emit('on-game', scope.row)">游戏</el-button>
          </div>
          <span v-else-if="col.key === 'gameIds'">{{ scope.row[col.key] ? scope.row[col.key].length : 0 }}</span>
          <span v-else-if="col.key === 'updateTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
          <span v-else-if="col.key === 'createTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { timeout } from '@/common/js/utils'
export default {
  name: 'ProjectGroupManagerTable',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    columns: {
      type: Array
    },
    height: {
      type: Number
    }
  }
}
</script>
